import { Paper } from 'components/Paper/styled';
import styled from 'styled-components';

export const Stage = styled.div`
  margin-left: auto;
  max-width: 687px;
  z-index: 1;
  width: 100%;
  transform-origin: right;
  transition-delay: 0.1s;
  transition: all 0.2s cubic-bezier(0.65, 0, 0.35, 1);
  transform: scaleX(0.6);
  opacity: 0;

  &.animated {
    transform: scaleX(1);
    opacity: 1;
  }
`;

export const PaperCustom = styled(Paper)`
  position: relative;
  border-radius: 0;
  height: 100vh;
  padding: 0;
`;
